<template>
    <div>
        <div class="extract-box">
            <content-box title="Extrato" tooltip-text="Detalhes do Extrato" :seeMoreFunction="openModal" :loader="loading">
                <template v-if="loading">
                    <HalfCircleSpinner :animation-duration="1000" :size="80" color="#007BFF" style="margin: 0px auto" />
                </template>
                <div v-if="!loading" class="extract-list">
                    <div v-for="(extract, index) in extractList" :key="extract.uuid">
                        <extract-line-details v-if="index <= 3" :extract="extract" />
                    </div>
                </div>
            </content-box>
        </div>
    </div>
</template>

<script>
import ContentBox from '@/components/supplier/dashboard/content-box';
import ExtractLineDetails from '@/components/supplier/dashboard/extract/extract-line-details';
import { HalfCircleSpinner } from 'epic-spinners';

export default {
    components: {
        ContentBox,
        ExtractLineDetails,
        HalfCircleSpinner,
    },

    props: {
        extractList: {
            type: Array,
            default: () => [],
        },
        openModal: {
            type: Function,
            default: () => {},
        },
        loading: {
            type: Boolean,
            required: false,
        },
    },
};
</script>

<style lang="scss" scoped>
.extract-box {
    @media (max-width: 768px) {
        padding: 26px 20px;
        margin-top: -6px;
        height: 70vh;
    }
}
.extract-list {
    padding-top: 20px;
}
</style>